import { render, staticRenderFns } from "./CustEditor.vue?vue&type=template&id=33199d18&scoped=true&"
import script from "./CustEditor.vue?vue&type=script&lang=js&"
export * from "./CustEditor.vue?vue&type=script&lang=js&"
import style0 from "./CustEditor.vue?vue&type=style&index=0&id=33199d18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33199d18",
  null
  
)

export default component.exports